<template>
<vueMain :title="$t('buttons.settings')">
  <div class="card">
    <div class="container-fluid">
      <div class="row">
        <nav class="col-lg-2 pl-0 pr-0 sidebar hover-bg">
          <b-nav vertical class="nav-pills">
            <b-nav-item v-if="user_is_api_admin" to="Users"><i class="fa fa-users"></i>{{ $t("buttons.users") }}</b-nav-item>
            <b-nav-item to="Settings" active><i class="fa fa-cog"></i> {{ $t("buttons.settings") }}</b-nav-item>
            <b-nav-item @click="logout"><i class="fa fa-sign-out"></i> {{ $t("buttons.logout") }}</b-nav-item>
          </b-nav>
        </nav>
        <div class="col-lg-10 pr-0">
          <div class="card-header text-center border-bottom-0">
            <h1 class="h4">{{ $t("labels.interface_settings") }}</h1>
          </div>
          <div class="card-body">
            <div class="form form-lines">
              <i18n></i18n>
              <kbnav></kbnav>
              <color-contrast></color-contrast>
              <font-size></font-size>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</vueMain>
</template>
<script>
import i18n from '@/components/Pages/Settings/i18n.vue';
import kbnav from '@/components/Pages/Settings/kbNav.vue';
import colorContrast from '@/components/Pages/Settings/colorContrast.vue';
import fontSize from '@/components/Pages/Settings/fontSize.vue';
import vueMain from '@/components/Layout/Main.vue';

export default {
  name: 'Settings',
  components: {
    i18n,
    kbnav,
    colorContrast,
    fontSize,
    vueMain
  },
  data: function () {
    return {
      user: {}
    };
  },
  computed: {
    user_is_api_admin () {
      try {
        return this.user.groups.map(x => { return x.name; }).includes('Admin');
      } catch (err) {
        return false;
      }
    }
  },
  methods: {
    logout: function () {
      document.cookie =
      'kernel_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
      document.location.replace('/');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Settings/Index.vue